import React, { useState, useEffect } from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import api from '../../utils/api';

const CreateCategoryDrawer = ({ isOpen = false, onClose, onCreated }) => {
  const [form, setForm] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name) {
      setError('El nombre es requerido');
      return;
    }
    setError('');
    setLoading(true);

    try {
      await api.post('/api/categories', form);
      onCreated?.();
      onClose();
      setForm({ name: '', description: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Error al crear categoría');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setForm({ name: '', description: '' });
      setError('');
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-50 overflow-hidden">
      <div className="absolute inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-y-0 right-0 max-w-full flex sm:w-full sm:max-w-md md:max-w-lg">
        <DialogPanel className="w-full bg-white shadow-2xl rounded-l-lg flex flex-col h-screen sm:rounded-r-lg">
          <div className="p-6 overflow-y-auto flex-1 space-y-6">
            <div>
              <DialogTitle className="text-2xl font-bold text-gray-900">Crear Nueva Categoría</DialogTitle>
              <p className="mt-2 text-sm text-gray-600">Añade una nueva categoría para organizar descargas. El campo nombre es obligatorio.</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Nombre *</label>
                <p className="text-xs text-gray-500 mt-1">El nombre de la categoría (e.g., "Aplicaciones Móviles").</p>
                <input
                  id="name"
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Nombre de la categoría"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  required
                  aria-required="true"
                />
              </div>
              <div>
                <label htmlFor="description" className="block text-sm font-medium text-gray-700">Descripción</label>
                <p className="text-xs text-gray-500 mt-1">Breve descripción de la categoría (opcional).</p>
                <textarea
                  id="description"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Descripción de la categoría"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  rows="4"
                />
              </div>
              {error && <p className="text-red-500 text-sm">{error}</p>}
            </form>
          </div>
          <div className="bg-gray-50 border-t px-6 py-4 flex justify-end gap-4 sticky bottom-0">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {loading ? 'Creando...' : 'Crear Categoría'}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default CreateCategoryDrawer;